import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'

interface SecondProps {
  isVoiceTerms: boolean
  setVoiceTerms: Dispatch<SetStateAction<boolean>>
}

export const SecondStep = ({
  isVoiceTerms,
  setVoiceTerms,
}: PropsWithChildren<SecondProps>) => {
  const [firstTerms, setFirstTerms] = useState<boolean>(false)
  const [secondTerms, setSecondTerms] = useState<boolean>(false)

  useEffect(() => {
    if (firstTerms && secondTerms) {
      return setVoiceTerms(true)
    }
    setVoiceTerms(false)
  }, [firstTerms, secondTerms])
  return (
    <div className="text-center space-y-4 md:h-[450px]">
      <ul className=" list-disc p-4 text-left bg-[#F6F8FB] text-[20px]">
        <li className="ml-4 mb-2">
          녹음하는 목소리는 타인의 목소리가 아닌 사용자 본인의 목소리여야
          합니다.
        </li>
        <li className="ml-4 mb-2">
          사용자 본인의 목소리가 아닌 타인의 목소리를 녹음하여 ‘패스트컷 내
          목소리’ 생성 목적으로 사용하여서는 아니 되며, 이를 위반할 경우 법적
          책임을 질 수 있습니다.
        </li>
        <li className="ml-4 mb-2">
          만들어진 목소리는 패스트컷의 이 계정에서만 사용할 수 있습니다.{' '}
        </li>
      </ul>

      <div className="flex flex-col ml-8">
        <div className="flex gap-2 font-[500] text-[18px] items-center">
          <input
            type="checkbox"
            className="w-[20px] h-[20px]"
            checked={firstTerms}
            onChange={(e) => {
              const value = e.target.checked
              setFirstTerms(value)
            }}
          />
          <span className="text-[#8F929B]">
            패스트컷{' '}
            <a
              className="text-href underline"
              href="https://angelleague.notion.site/234ba20e97f3803f8a07fd5933a8a022?source=copy_link"
              target="_blank"
              rel="noreferrer"
            >
              내 목소리 규정 동의
            </a>
          </span>
        </div>
        <div className="flex gap-2 font-[500] text-[18px] items-center">
          <input
            type="checkbox"
            className="w-[20px] h-[20px]"
            checked={secondTerms}
            onChange={(e) => {
              const value = e.target.checked
              setSecondTerms(value)
            }}
          />
          <span className="text-[#8F929B]">
            패스트컷{' '}
            <a
              className="text-href underline"
              href="https://angelleague.notion.site/db42ab5e75004f629ce5114b6fa7f9a4?source=copy_link"
              target="_blank"
              rel="noreferrer"
            >
              개인정보 처리방침 동의
            </a>
          </span>
        </div>
      </div>
    </div>
  )
}
